import { RebuildNotice } from '@/components/RebuildNotice'
export default function Page() { return <RebuildNotice title="Bids" hint="Bid acceptance rates, anomalies." /> }
